import { useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { PlayCircle } from 'lucide-react';

/** Step 0 — the welcome video, played once before setup begins. Until an admin
 *  uploads one, a placeholder card appears instead of an empty player. */
export function IntroVideoDialog({ open, url = '', title = 'Meet your Study Buddies', skipLabel = 'Skip intro', onDone }) {
  const [playing, setPlaying] = useState(false);
  const isFile = /\.(mp4|webm|ogg|mov)(\?|$)/i.test(url || '');
  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent className="max-w-2xl rounded-3xl p-0 overflow-hidden" hideClose
        onEscapeKeyDown={e => e.preventDefault()}
        onPointerDownOutside={e => e.preventDefault()}
        onInteractOutside={e => e.preventDefault()}
        data-testid="intro-video-dialog">
        <div className="px-6 pt-6 pb-3 text-center">
          <DialogTitle className="font-heading text-2xl font-bold text-slate-900">{title}</DialogTitle>
          <DialogDescription className="text-sm text-slate-500 font-body mt-1">
            A quick hello before we set up your learning.
          </DialogDescription>
        </div>
        <div className="px-6">
          <div className="rounded-2xl overflow-hidden bg-slate-900 aspect-video flex items-center justify-center">
            {!url ? (
              <div className="text-center px-6" data-testid="intro-video-placeholder">
                <PlayCircle className="w-10 h-10 text-white/40 mx-auto" />
                <p className="text-xs font-body text-white/60 mt-2">
                  The welcome video goes here — an admin can add it any time.
                </p>
              </div>
            ) : isFile ? (
              <video src={url} controls autoPlay playsInline className="w-full h-full"
                data-testid="intro-video-player" onPlay={() => setPlaying(true)} />
            ) : (
              <iframe src={url} title={title} allow="autoplay; fullscreen" allowFullScreen
                className="w-full h-full" data-testid="intro-video-frame" />
            )}
          </div>
        </div>
        <div className="flex items-center justify-between px-6 py-4">
          <span className="text-[11px] font-body text-slate-400">
            {playing ? 'Enjoy — we’ll continue right after.' : 'You can watch it again from Help any time.'}
          </span>
          <Button size="sm" className="rounded-full font-heading text-xs" data-testid="intro-video-continue"
            onClick={onDone}>
            {url ? 'Continue' : skipLabel}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default IntroVideoDialog;
